import isNumber from 'lodash/isNumber'

// return only '' or number to callback
export const returnNumber = (value, callback) => {
  if (value === '') return callback(String(''))
  if (value === '-') return callback(-1)
  const number = parseFloat(value)
  if (!isNumber(number)) return callback(0)
  if (isNaN(number)) return callback(0)
  if (number > Number.MAX_SAFE_INTEGER) return callback(Number.MAX_SAFE_INTEGER)
  if (number < Number.MIN_SAFE_INTEGER) return callback(Number.MIN_SAFE_INTEGER)
  if (value.endsWith('.')) return callback(number.toFixed(1))
  return callback(number)
}



// WEBPACK FOOTER //
// ./src/helpers/numberHelpers.js